export const subAccounts = {
  title: 'Sub-Accounts',
  subtitle: 'Manage team members and reseller customers',
  navTitle: 'Sub-Accounts',
  invite: 'Invite',
  mySubAccounts: 'My Sub-Accounts',
  myParents: 'My Parent Accounts',
  filterAll: 'All',
  search: 'Search...',
  loading: 'Loading sub-accounts...',
  empty: 'No Sub-Accounts',
  emptyChildren: 'You have no sub-accounts yet. Invite team members or reseller customers.',
  emptyParents: 'You are not assigned to any parent account.',
  billingShared: 'Shared Billing',
  billingIndependent: 'Independent Billing',
  status: {
    active: 'Active',
    pending: 'Pending',
    deactivated: 'Deactivated',
    expired: 'Expired'
  },
  roles: {
    viewer: 'Viewer',
    editor: 'Editor',
    manager: 'Manager'
  },
  roleDescriptions: {
    viewer: 'Read-only access to domains, mail and hosting — no changes.',
    editor: 'Read and edit domains, mail and hosting — no deletion.',
    manager: 'Full access including deletion. Billing, payments and account settings stay with the owner.'
  },
  inviteSlider: {
    title: 'Invite Sub-Account',
    subtitle: 'Invite a team member or reseller customer',
    email: 'Email Address',
    emailPlaceholder: "email{'@'}example.com",
    type: 'Relationship Type',
    billingMode: 'Billing Mode',
    teamRole: 'Team Role',
    label: 'Label',
    labelPlaceholder: 'e.g. Dev Team, Agency XY...',
    send: 'Send Invitation'
  },
  editSlider: {
    title: 'Edit Sub-Account',
    type: 'Type',
    status: 'Status',
    billingMode: 'Billing Mode',
    teamRole: 'Team Role',
    label: 'Label'
  },
  deactivateModal: {
    title: 'Deactivate Sub-Account?',
    message: 'Are you sure you want to deactivate the relationship with {account}?',
    warning: 'The sub-account will lose access to your resources.',
    confirm: 'Deactivate'
  },
  contextBanner: {
    acting: 'You are acting as {context}',
    teamScoped: 'limited to your team role',
    returnBtn: 'Return to your account'
  },
  inviteAccept: {
    title: 'Accept Invitation',
    subtitle: '{name} has invited you as a sub-account',
    from: 'From',
    type: 'Type',
    billing: 'Billing',
    accept: 'Accept Invitation',
    decline: 'Decline',
    loading: 'Loading invitation...',
    errorTitle: 'Error',
    invalidToken: 'This invitation is invalid or has expired.',
    loadError: 'Could not load the invitation.',
    acceptError: 'Could not accept the invitation.',
    successTitle: 'Invitation Accepted',
    successMessage: 'You are now linked as a sub-account.',
    goHome: 'Go Home',
    goDashboard: 'Go to Dashboard'
  },
  resources: {
    tab: 'Resources',
    title: 'Sub-Account Resources',
    subtitle: 'Overview of all domains and mail accounts of your sub-accounts',
    loading: 'Loading resources...',
    empty: 'No Resources',
    emptyMessage: 'Your sub-accounts don\'t have any domains or mail accounts yet.',
    domains: 'Domains',
    mailAccounts: 'Mail Accounts',
    domainStatus: {
      active: 'Active',
      pending_delete: 'Cancelled',
      deleted: 'Deleted',
      suspended: 'Suspended',
      trade_out: 'Transfer',
      transfer_pending: 'Transfer pending',
      external: 'External'
    },
    activeUntil: 'Active until',
    switchTo: 'Manage',
    totalDomains: 'Total domains',
    totalMail: 'Total mail accounts'
  },
  notifications: {
    inviteSent: 'Invitation Sent',
    inviteSentMessage: 'The invitation has been sent successfully.',
    updated: 'Updated',
    updatedMessage: 'The sub-account relationship has been updated.',
    deactivated: 'Deactivated',
    deactivatedMessage: 'The sub-account relationship has been deactivated.'
  }
} as const
